<template>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <circle id="path-1" cx="8.57142857" cy="8.57142857" r="8.57142857"></circle>
      <polygon id="path-3"
               points="2.4500589 4.64348674 0.620740079 2.81416792 0 3.434908 2.4500589 5.8849669 7.71428571 0.620740079 7.09354564 0"></polygon>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Task-Report---Task" transform="translate(-375.000000, -563.000000)">
        <rect fill="#FFFFFF" x="0" y="0" width="1440" height="1118"></rect>
        <g id="Molecules/Task/Log" transform="translate(370.000000, 551.000000)">
          <g id="Background"></g>
          <g id="Label" transform="translate(5.000000, 4.000000)">
            <g id="Atoms/Skill-Checked/Default" transform="translate(0.000000, 8.000000)">
              <g id="Atoms/Elements/Edge" transform="translate(3.428571, 3.428571)">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <use id="Mask" fill="#D8D8D8" xlink:href="#path-1"></use>
                <g id="Variables/Palette/Brand/05-Pri-Gradient" mask="url(#mask-2)" :fill="backgroundColour">
                  <rect id="Color" x="0" y="0" width="17.1428571" height="17.1428571"></rect>
                </g>
              </g>
              <g id="Variables/Icon/Tick" transform="translate(5.142857, 5.142857)">
                <g id="Group" transform="translate(3.000000, 3.857143)">
                  <mask id="mask-4" fill="white">
                    <use xlink:href="#path-3"></use>
                  </mask>
                  <use id="Icon" fill="#fff" fill-rule="nonzero" xlink:href="#path-3"></use>
                  <g id="↳-🎨Color" mask="url(#mask-4)" fill="#FFFFFF">
                    <g transform="translate(-3.000000, -3.857143)" id="Color">
                      <rect x="0" y="0" width="13.7142857" height="13.7142857"></rect>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CheckedRoundedIcon',

  props: {
    success: {
      required: false,
      default: true,
    },
  },

  computed: {
    backgroundColour () {
      return this.success ? '#2ecc71' : '#d8d8d8';
    },
  },
};
</script>

<style scoped>

</style>
